import { render, staticRenderFns } from "./SearchRecipePage.vue?vue&type=template&id=b4ee1ee0&"
import script from "./SearchRecipePage.vue?vue&type=script&lang=js&"
export * from "./SearchRecipePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports